import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "../../api/axios";
import "./styles/AdminServiceAreaPageEditor.css";
import "../../pages/LocalLandingPage/LocalLandingPage.css";

const AdminServiceAreaPageEditor = () => {
  const { id } = useParams();
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [noPage, setNoPage] = useState(false); // Track if no existing page
  const [showForm, setShowForm] = useState(false); // Track showing of form when creating new page

  const [csrfToken, setCsrfToken] = useState("");

    const [reviews, setReviews] = useState([]);
  const [images, setImages] = useState([]);



  useEffect(() => {
    const token = document.cookie
      .split("; ")
      .find((row) => row.startsWith("csrfToken="))
      ?.split("=")[1];
    if (token) setCsrfToken(token);
  }, []);


  useEffect(() => {
    const fetchPageData = async () => {
      try {
        const { data } = await axios.get(`/api/admin/service-areas/${id}/page`, {
          withCredentials: true,
        });

        if (!data?.data) {
          setNoPage(true);
        } else {
          const page = data.data;
          setForm({
            ...page,
            featured_review_ids: Array.isArray(page.featured_review_ids)
              ? page.featured_review_ids
              : JSON.parse(page.featured_review_ids || "[]"),
            featured_image_ids: Array.isArray(page.featured_image_ids)
              ? page.featured_image_ids
              : JSON.parse(page.featured_image_ids || "[]"),
          });
        }

      } catch (err) {
        console.error("🔥 Error fetching page data:", err);
        setNoPage(true);
      } finally {
        setLoading(false);
      }
    };
    fetchPageData();
  }, [id]);

    useEffect(() => {
    const fetchLists = async () => {
      try {
        const [reviewsRes, imagesRes] = await Promise.all([
          axios.get("/api/public/reviews"),
          axios.get("/api/public/gallery/images", { withCredentials: true }),
        ]);

        setReviews(reviewsRes.data.reviews || []);
        setImages(imagesRes.data.images || []);
      } catch (err) {
        console.error("🔥 Error fetching reviews or images:", err);
      }
    };

    fetchLists();
  }, []);


    const handleReviewSelect = (e) => {
    const selected = Array.from(e.target.selectedOptions, (opt) => parseInt(opt.value));
    // Limit to 3 max
    setForm((prev) => ({ ...prev, featured_review_ids: selected.slice(0, 3) }));
  };

  const toggleImage = (id) => {
    setForm((prev) => {
      const current = prev.featured_image_ids || [];
      if (current.includes(id)) {
        return { ...prev, featured_image_ids: current.filter((imgId) => imgId !== id) };
      }
      if (current.length >= 6) {
        alert("Max 6 images allowed.");
        return prev;
      }
      return { ...prev, featured_image_ids: [...current, id] };
    });
  };



  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };



const handleSave = async () => {
  if (!csrfToken) {
    alert("🚨 CSRF token missing — please refresh and try again.");
    return;
  }

  setSaving(true);
  try {
    // ✅ Normalize arrays before sending
    const payload = {
      ...form,
      featured_review_ids: Array.isArray(form.featured_review_ids)
        ? form.featured_review_ids
        : [],
      featured_image_ids: Array.isArray(form.featured_image_ids)
        ? form.featured_image_ids
        : [],
    };

    await axios.post(`/api/admin/service-areas/${id}/page`, payload, {
      withCredentials: true,
      headers: { "x-csrf-token": csrfToken },
    });

    alert("✅ Page saved successfully!");
    setNoPage(false);
    setShowForm(true);
  } catch (err) {
    console.error("🔥 Error saving page:", err);
    alert("🔥 Error saving page");
  } finally {
    setSaving(false);
  }
};



  


  // === CLEAN RETURN ===
  return (
    <div className="admin-messages-container">
      <h2 className="messages-title">Edit Service Area Page</h2>

      {loading ? (
        <p className="messages-loading">Loading page...</p>
      ) : noPage && !showForm ? (
        <div className="messages-empty">
          <p>No page exists for this service area yet.</p>
          <button
            className="btn archive-btn"
            onClick={() => setShowForm(true)}
          >
            <i className="fa-solid fa-plus"></i> Create Page
          </button>
        </div>
      ) : (
        <>
          <div className="admin-page-editor-wrapper">
            {/* ===== LEFT: Form ===== */}
            <div className="admin-page-editor-form">
              <div className="table-section">
                <h3 className="table-section-title">Page Content</h3>

                <div className="form-group">
                  <label>Meta Title</label>
                  <input
                    type="text"
                    name="meta_title"
                    value={form.meta_title || ""}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-group">
                  <label>Meta Description</label>
                  <textarea
                    name="meta_description"
                    value={form.meta_description || ""}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-group">
                  <label>Hero Heading</label>
                  <input
                    type="text"
                    name="hero_heading"
                    value={form.hero_heading || ""}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-group">
                  <label>Hero Subtext</label>
                  <textarea
                    name="hero_subtext"
                    value={form.hero_subtext || ""}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-group">
                  <label>Main Subheading</label>
                  <input
                    type="text"
                    name="main_subheading"
                    value={form.main_subheading || ""}
                    onChange={handleChange}
                    placeholder="#1 Gutters in Florida"
                  />
                </div>

                <div className="form-group">
                  <label>Main Heading</label>
                  <input
                    type="text"
                    name="main_heading"
                    value={form.main_heading || ""}
                    onChange={handleChange}
                    placeholder="Gutter Installation"
                  />
                </div>


                <div className="form-group">
                  <label>Main Paragraph</label>
                  <textarea
                    name="main_paragraph"
                    value={form.main_paragraph || ""}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-group">
                  <label>CTA Text</label>
                  <input
                    type="text"
                    name="cta_text"
                    value={form.cta_text || ""}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-group">
                  <label>Layout Variant</label>
                  <select
                    name="layout_variant"
                    value={form.layout_variant || "A"}
                    onChange={handleChange}
                  >
                    <option value="A">Layout A</option>
                    <option value="B">Layout B</option>
                  </select>
                </div>

                                <div className="form-group">
                  <label>Featured Reviews (up to 3)</label>
                  <select
                    multiple
                    name="featured_review_ids"
                    value={form.featured_review_ids || []}
                    onChange={handleReviewSelect}
                  >
                    {reviews.map((r) => (
                      <option key={r.id} value={r.id}>
                        {r.author_name ? `${r.author_name} — ${r.city}` : `Review #${r.id}`}
                      </option>
                    ))}
                  </select>
                  <small className="hint-text">Hold Ctrl/Cmd to select multiple</small>
                </div>

                <div className="form-group">
                  <label>Featured Gallery Images (up to 6)</label>
                  <div className="gallery-multiselect">
                    {images.map((img) => (
                      <label key={img.id} className="gallery-option">
                        <input
                          type="checkbox"
                          checked={(form.featured_image_ids || []).includes(img.id)}
                          onChange={() => toggleImage(img.id)}
                        />
                        <img
                          src={`${process.env.REACT_APP_API_URL}/uploads/gallery/${img.image_url}`}
                          alt={img.alt_text || "Gallery"}
                          className="gallery-thumb"
                        />
                      </label>
                    ))}
                  </div>
                </div>


                <button
                  className="btn save-btn"
                  onClick={handleSave}
                  disabled={saving}
                >
                  {saving ? "Saving..." : "💾 Save Page"}
                </button>
              </div>
            </div>

            {/* ===== RIGHT: Live Preview ===== */}
            <div className="admin-page-editor-preview">
              <div
                className={`page-wrapper layout-${form.layout_variant || "A"}`}
              >
                <div className="page-content-container">
                  <div className="content-wrapper">
                    <div className="page-content">
                      <div className="page-content-wrapper">
                        <section className="local-hero">
                          <h1>
                            {form.hero_heading || "Sample Hero Heading"}
                          </h1>
                          {form.hero_subtext && <p>{form.hero_subtext}</p>}
                        </section>

                        {form.main_paragraph && (
                          <section className="local-section">
                            <p>{form.main_paragraph}</p>
                          </section>
                        )}

                        <section className="local-section">
                          <h2>Our Gutter Services</h2>
                          <ul className="local-list">
                            <li>Seamless Gutter Installation</li>
                            <li>Gutter Guard Installation</li>
                            <li>Downspout Repair & Replacement</li>
                            <li>Gutter Cleaning & Maintenance</li>
                          </ul>
                        </section>

                        {form.cta_text && (
                          <section className="local-section cta-section">
                            <a href="#" className="cta-button">
                              {form.cta_text}
                            </a>
                          </section>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default AdminServiceAreaPageEditor;
